(() => {
  const modal = document.getElementById('modal-productPriceMatch');

  if (!modal) return;

  const formId = 'ProductPriceMatchForm';
  const recentFormKey = 'the4:recentform';
  const activeProductStorageKey = 'product-price-match:active-product';
  const selectors = {
    card: '[data-product-price-match-card]',
    title: '[data-product-price-match-title]',
    sku: '[data-product-price-match-sku]',
    skuValue: '[data-product-price-match-sku-value]',
    price: '[data-product-price-match-price]',
    image: '[data-product-price-match-image]',
    competitorUrl: '[data-price-match-competitor-url]',
    competitorPrice: '[data-price-match-competitor-price]',
    notes: '[data-price-match-notes]',
    urlError: '[data-price-match-url-error]',
    pageLink: '[data-price-match-page-link]',
    hiddenTitle: '[data-price-match-hidden-product-title]',
    hiddenUrl: '[data-price-match-hidden-product-url]',
    hiddenSku: '[data-price-match-hidden-sku]',
    hiddenCurrentPrice: '[data-price-match-hidden-current-price]',
    hiddenBody: '[data-price-match-hidden-body]',
  };

  const getElement = (selector) => modal.querySelector(selector);
  const form = document.getElementById(formId);

  if (!form) return;

  const nodes = {
    card: getElement(selectors.card),
    title: getElement(selectors.title),
    sku: getElement(selectors.sku),
    skuValue: getElement(selectors.skuValue),
    price: getElement(selectors.price),
    image: getElement(selectors.image),
    competitorUrl: getElement(selectors.competitorUrl),
    competitorPrice: getElement(selectors.competitorPrice),
    notes: getElement(selectors.notes),
    urlError: getElement(selectors.urlError),
    pageLink: getElement(selectors.pageLink),
    hiddenTitle: getElement(selectors.hiddenTitle),
    hiddenUrl: getElement(selectors.hiddenUrl),
    hiddenSku: getElement(selectors.hiddenSku),
    hiddenCurrentPrice: getElement(selectors.hiddenCurrentPrice),
    hiddenBody: getElement(selectors.hiddenBody),
  };

  const normalizeUrl = (value) => {
    const trimmed = String(value || '').trim();
    if (!trimmed) return '';
    if (/^[a-z][a-z0-9+.-]*:\/\//i.test(trimmed)) return trimmed;
    return `https://${trimmed}`;
  };

  const sanitizePrice = (value) => {
    const raw = String(value || '');
    let sanitized = raw.replace(/[^0-9.]/g, '');
    const firstDot = sanitized.indexOf('.');

    if (firstDot !== -1) {
      sanitized =
        sanitized.slice(0, firstDot + 1) + sanitized.slice(firstDot + 1).replace(/\./g, '');
    }

    if (sanitized.startsWith('.')) {
      sanitized = `0${sanitized}`;
    }

    return sanitized;
  };

  const escapeHtml = (value) =>
    String(value || '').replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    }[char]));

  const buildPriceMarkup = ({ price, compareAtPrice }) => {
    const hasCompareAtPrice = Boolean(compareAtPrice);
    const compareMarkup = compareAtPrice
      ? `<hdt-compare-at-price class="hdt-compare-at-price"><span class="sr-only sr-only--inline">Regular price</span><span class="hdt-money">${escapeHtml(compareAtPrice)}</span></hdt-compare-at-price>`
      : '';

    return `<div class="hdt-product__price"><div class="hdt-price-wrapp"><div class="hdt-price__list${hasCompareAtPrice ? ' is-sale' : ''}">${compareMarkup}<hdt-price class="hdt-price"><span class="sr-only sr-only--inline">Sale price</span><span class="hdt-money">${escapeHtml(price)}</span></hdt-price></div></div></div>`;
  };

  const readVariantIdFromForm = (productFormId) => {
    if (!productFormId) return '';

    const variantPicker = document.querySelector(`hdt-variant-picker[form="${productFormId}"]`);
    const pickerVariantId = variantPicker?.getAttribute('selected-variant');
    if (pickerVariantId) return pickerVariantId;

    const formNode = document.getElementById(productFormId);
    if (!formNode) return '';

    const selectedControl = formNode.querySelector('[name="id"]:not([disabled])');
    if (selectedControl?.value) return selectedControl.value;

    const fallbackControl = formNode.querySelector('select[name="id"] option:checked');
    return fallbackControl?.value || '';
  };

  const getTriggerData = (button) => {
    const wrap = button.closest('[data-product-price-match-trigger-wrap]');
    const variantScript = wrap?.querySelector('[data-product-price-match-variants]');
    let variantPayload = null;

    if (variantScript?.textContent) {
      try {
        variantPayload = JSON.parse(variantScript.textContent);
      } catch (error) {
        variantPayload = null;
      }
    }

    const productFormId = wrap?.dataset.productFormId || '';
    const liveVariantId = readVariantIdFromForm(productFormId);
    const fallbackVariantId = button.dataset.selectedVariantId || '';
    const activeVariantId = String(liveVariantId || fallbackVariantId || '');
    const variants = Array.isArray(variantPayload?.variants) ? variantPayload.variants : [];
    const activeVariant =
      variants.find((variant) => String(variant.id) === activeVariantId) ||
      variants.find((variant) => String(variant.id) === String(fallbackVariantId)) ||
      variants[0] ||
      null;

    return {
      productTitle: variantPayload?.productTitle || button.dataset.productTitle || '',
      productHandle: variantPayload?.productHandle || button.dataset.productHandle || '',
      productUrl: variantPayload?.productUrl || button.dataset.productUrl || '',
      productId: variantPayload?.productId || button.dataset.productId || '',
      variantId: activeVariant ? String(activeVariant.id || '') : String(fallbackVariantId),
      variantTitle: activeVariant?.title || button.dataset.selectedVariantTitle || '',
      sku: activeVariant?.sku || button.dataset.selectedVariantSku || '',
      price: activeVariant?.price || button.dataset.selectedVariantPrice || '',
      compareAtPrice:
        activeVariant?.compareAtPrice || button.dataset.selectedVariantCompareAtPrice || '',
      productVendor: activeVariant?.vendor || button.dataset.productVendor || '',
      productType: activeVariant?.productType || button.dataset.productType || '',
      image: activeVariant?.image || button.dataset.selectedVariantImage || '',
      pageUrl: button.dataset.priceMatchPageUrl || modal.dataset.priceMatchPageUrl || '',
      pagePlaceholder:
        (button.dataset.priceMatchPagePlaceholder || modal.dataset.priceMatchPagePlaceholder || '') === 'true',
    };
  };

  const getTrackingPayload = (data = getActiveProductData()) => ({
    form_type: 'price_match',
    form_id: formId,
    product_id: data.productId || '',
    product_handle: data.productHandle || '',
    product_title: data.productTitle || '',
    variant_id: data.variantId || '',
    variant_sku: data.sku || '',
    variant_title: data.variantTitle || '',
    product_vendor: data.productVendor || '',
    product_type: data.productType || '',
    product_url: data.productUrl || '',
    page_url: window.location.href,
    modal_source: 'product_page',
  });

  const publishOpenEvent = (data) => {
    window.ODSProductModalTracking?.publish('ods:price_match_open', getTrackingPayload(data));
  };

  const storePendingSubmitEvent = () => {
    const trackingPayload = getTrackingPayload(getActiveProductData());
    const competitorPrice = window.ODSProductModalTracking?.sanitizePrice(nodes.competitorPrice?.value);
    const competitorDomain = window.ODSProductModalTracking?.getDomainFromUrl(nodes.competitorUrl?.value);

    if (competitorPrice !== undefined) {
      trackingPayload.competitor_price = competitorPrice;
    }
    if (competitorDomain) {
      trackingPayload.competitor_domain = competitorDomain;
    }

    window.ODSProductModalTracking?.storePendingSubmission(formId, trackingPayload);
  };

  const setPageLink = ({ pageUrl, pagePlaceholder }) => {
    if (!nodes.pageLink) return;
    if (pageUrl) {
      nodes.pageLink.setAttribute('href', pageUrl);
    }
    if (pagePlaceholder) {
      nodes.pageLink.setAttribute('data-price-match-page-placeholder', 'true');
    } else {
      nodes.pageLink.removeAttribute('data-price-match-page-placeholder');
    }
  };

  const syncHiddenFields = (data) => {
    nodes.hiddenTitle.value = data.productTitle || '';
    nodes.hiddenUrl.value = data.productUrl || '';
    nodes.hiddenSku.value = data.sku || '';
    nodes.hiddenCurrentPrice.value = data.price || '';
    nodes.hiddenBody.value = 'Price match enquiry submitted.';
  };

  const hydrateLockedProduct = (data) => {
    if (nodes.title) {
      nodes.title.textContent = data.productTitle || '';
    }
    if (nodes.sku) {
      const hasSku = Boolean(data.sku);
      nodes.sku.hidden = !hasSku;
      if (nodes.skuValue) {
        nodes.skuValue.textContent = hasSku ? data.sku : '';
      }
    }
    if (nodes.price) {
      nodes.price.innerHTML = buildPriceMarkup({
        price: data.price || '',
        compareAtPrice: data.compareAtPrice || '',
      });
    }
    if (nodes.image) {
      if (data.image) {
        nodes.image.src = data.image;
        nodes.image.alt = data.productTitle || 'Selected product';
      } else {
        nodes.image.removeAttribute('src');
        nodes.image.alt = data.productTitle || '';
      }
    }

    setPageLink(data);
    syncHiddenFields(data);
    modal.dataset.activeProduct = JSON.stringify(data);
  };

  const getActiveProductData = () => {
    try {
      return JSON.parse(modal.dataset.activeProduct || '{}');
    } catch (error) {
      return {};
    }
  };

  const setUrlError = (message) => {
    if (!nodes.competitorUrl || !nodes.urlError) return;
    const hasError = Boolean(message);
    nodes.competitorUrl.setAttribute('aria-invalid', hasError ? 'true' : 'false');
    nodes.urlError.hidden = !hasError;
    nodes.urlError.textContent = message || '';
  };

  const validateCompetitorUrl = () => {
    if (!nodes.competitorUrl) return true;

    const rawValue = nodes.competitorUrl.value.trim();
    if (!rawValue) {
      setUrlError('Please enter a valid competitor website URL.');
      return false;
    }

    const normalized = normalizeUrl(rawValue);

    try {
      const parsed = new URL(normalized);
      if (!['http:', 'https:'].includes(parsed.protocol)) {
        throw new Error('Invalid protocol');
      }
      nodes.competitorUrl.value = normalized;
      setUrlError('');
      return true;
    } catch (error) {
      setUrlError('Please enter a valid competitor website URL.');
      return false;
    }
  };

  modal.addEventListener('dialog:opening', () => {
    const trigger = modal.closest('hdt-modal')?.dialog?.btnOpening;
    if (!trigger?.matches('[data-product-price-match-open]')) return;
    const triggerData = getTriggerData(trigger);
    hydrateLockedProduct(triggerData);
    publishOpenEvent(triggerData);
  });

  // The independent product script can load before Kalles' module dependencies.
  // Retain an early activation, then use the normal hydrated dialog lifecycle.
  let pendingTrigger = null;
  let pendingOpen = null;
  const openWhenReady = (trigger = null) => {
    const owner = modal.closest('hdt-modal');
    if (!owner) return;
    if (owner.dialog === modal && typeof owner.open === 'function') {
      if (trigger) modal.btnOpening = trigger;
      owner.open();
      return;
    }

    pendingTrigger = trigger;
    if (pendingOpen) return;
    pendingOpen = customElements.whenDefined('hdt-modal').then(() => {
      const retainedTrigger = pendingTrigger;
      pendingTrigger = null;
      if (!owner.isConnected || !modal.isConnected
        || (retainedTrigger && (!retainedTrigger.isConnected
          || retainedTrigger.getAttribute('aria-controls') !== modal.id))
        || document.getElementById(modal.id) !== modal || modal.closest('hdt-modal') !== owner
        || modal.open || owner.dialog !== modal || typeof owner.open !== 'function') return;
      if (retainedTrigger) modal.btnOpening = retainedTrigger;
      owner.open();
    }).finally(() => { pendingOpen = null; });
  };
  document.addEventListener('click', (event) => {
    const trigger = event.target instanceof Element
      ? event.target.closest('[data-product-price-match-open]') : null;
    const owner = modal.closest('hdt-modal');
    if (!trigger || trigger.getAttribute('aria-controls') !== modal.id || !owner
      || document.getElementById(modal.id) !== modal) return;
    if (owner.dialog === modal && typeof owner.open === 'function') return;

    event.preventDefault();
    event.stopImmediatePropagation();
    openWhenReady(trigger);
  }, { capture: true });

  if (nodes.competitorUrl) {
    nodes.competitorUrl.addEventListener('input', () => {
      setUrlError('');
      syncHiddenFields(getActiveProductData());
    });
    nodes.competitorUrl.addEventListener('blur', validateCompetitorUrl);
  }

  if (nodes.competitorPrice) {
    const syncPrice = () => {
      const sanitized = sanitizePrice(nodes.competitorPrice.value);
      if (sanitized !== nodes.competitorPrice.value) {
        nodes.competitorPrice.value = sanitized;
      }
      syncHiddenFields(getActiveProductData());
    };

    nodes.competitorPrice.addEventListener('input', syncPrice);
    nodes.competitorPrice.addEventListener('blur', syncPrice);
  }

  if (nodes.notes) {
    nodes.notes.addEventListener('input', () => {
      syncHiddenFields(getActiveProductData());
    });
  }

  form.addEventListener('submit', (event) => {
    if (!validateCompetitorUrl()) {
      event.preventDefault();
      nodes.competitorUrl?.focus();
      return;
    }

    if (nodes.competitorPrice) {
      nodes.competitorPrice.value = sanitizePrice(nodes.competitorPrice.value);
    }

    syncHiddenFields(getActiveProductData());
    storePendingSubmitEvent();
    sessionStorage.setItem(recentFormKey, formId);
    sessionStorage.setItem(activeProductStorageKey, modal.dataset.activeProduct || '{}');
  });

  const recentForm = sessionStorage.getItem(recentFormKey) || '';
  const postedSuccessfully = window.location.search.includes('contact_posted=true');
  const hasErrors = Boolean(form.querySelector('.hdt-form-message--error'));
  const savedActiveProduct = sessionStorage.getItem(activeProductStorageKey);

  if (savedActiveProduct) {
    try {
      hydrateLockedProduct(JSON.parse(savedActiveProduct));
    } catch (error) {
      sessionStorage.removeItem(activeProductStorageKey);
    }
  } else {
    setPageLink({
      pageUrl: modal.dataset.priceMatchPageUrl || '',
      pagePlaceholder: modal.dataset.priceMatchPagePlaceholder === 'true',
    });
  }

  if (hasErrors) {
    openWhenReady();
  }
  modal.dataset.productPriceMatchInitialized = 'true';
})();
